module.exports = __webpack_public_path__ + "img/Agreement.d755021e.svg";